<template>
  <div class="related-project">
    <crumb-tit>
      <span slot="breadTit">关联项目</span>
      <span slot="secondTit">关联项目</span>
    </crumb-tit>
    <a-alert
      class="relate-pro-alert"
      type="info"
      show-icon
    >
      <template
        slot="message"
      >
        可关联同一组织下的询盘管理项目和会员管理项目，关联后，系统会根据询盘管理项目中的信息，识别出手机号码/邮箱，<br>
        自动在当前会员管理项目中创建会员（如手机号码/邮箱信息已存在，不会重复创建）。
      </template>
    </a-alert>
    <a-form>
      <a-form-item label="关联编码">
        <a-button
          @click="addRelatePro"
        >
          添加关联
        </a-button>
        <a-form
          v-if="isFormShow"
          :form="form"
          layout="inline"
          @submit.prevent="saveForm"
        >
          <a-form-item>
            <a-input
              v-decorator="[
                'relateCode',
                {rules: [{ required: true, message: '请输入关联编码' }], initialValue: '' }
              ]"
              placeholder="请输入关联编码"
            />
          </a-form-item>
          <a-form-item>
            <a-button
              type="primary"
              html-type="submit"
            >
              提交
            </a-button>
            <a-button
              html-type="reset"
              @click="isFormShow = false"
            >
              取消
            </a-button>
          </a-form-item>
        </a-form>
        <p class="relate-pro-tip">
          在会员管理项目中，【项目配置-关联项目】处，复制关联编码填入此处即可。
        </p>
        <div v-if="!loading">
          <div
            v-for="(item, index) in relativeDatas"
            :key="index"
            class="relate-pro-item"
          >
            {{ index + 1 }}. {{ item.comname }} | {{ item.projectname }}
            <a-button
              class="m-l-16"
              @click="unRelatedPro(item)"
            >
              解除关联
            </a-button>
          </div>
        </div>
        <div
          v-else
          class=""
        >
          <a-spin />
        </div>
      </a-form-item>
      <!-- <a-form-item label="关联项目">
        <div
          class="relate-pro-item"
          v-for="(item, index) in relativeDatas"
          :key="index"
        >
          {{ index + 1 }}. {{ item.comname }} | {{ item.projectname }}
          <a-button class="m-l-16" @click="unRelatedPro(item)"
            >解除关联</a-button
          >
        </div>
      </a-form-item> -->
    </a-form>
  </div>
</template>
<script>
import CrumbTit from '@/components/pc/config/CrumbTit'
import { mapActions, mapState } from 'vuex'
export default {
  components: {
    CrumbTit
  },
  data () {
    return {
      form: this.$form.createForm(this),
      isFormShow: false
    }
  },
  computed: {
    ...mapState('config/relativeProject', ['relativeDatas', 'loading', 'relateCode'])
  },
  async created () {
    await this.fetchRelativeProData()
  },
  methods: {
    ...mapActions('config/relativeProject', ['addRelativePro', 'fetchRelativeProData', 'relieveRelativePro']),
    addRelatePro () {
      this.isFormShow = true
    },
    unRelatedPro (record) {
      this.$confirm({
        title: <div>解除关联</div>,
        content: <div>解除关联后，将<span class="fs-red">不再</span>根据 组织名称-项目名称 中的询盘数据，<span class="fs-red">同步创建会员，已创建的会员不会删除</span>，确定要解除关联吗？</div>,
        closable: true,
        centered: true,
        okText: '确定',
        okType: 'primary',
        cancelText: '取消',
        icon: () => <i class="iconfont iconicon-test68" />,
        class: 'confirm-warn-modal relate-tip',
        onOk: async () => {
          const chain = await this.relieveRelativePro({ pid: record.projectid })
          // chain
          //   .onSuccess(() => {
          //     this.getList()
          //   })
        }
      })
    },
    async saveForm () {
      this.submitting = true
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const chain = await this.addRelativePro()
          chain
            .params(values)
            .onSuccess(raw => {
              this.isFormShow = false
            })
            .onNetSuccess((res) => {
              // if (res.data.error) {
              //   this.$message.warning(res.data.message || res.data.payload[0].message)
              // }
            })
            .fetch()
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.related-project::v-deep{
  .ant-row:after {
    clear: both;
    content: '.';
    display: block;
    height: 0;
    visibility: hidden;
  }
  .ant-row {
    padding-left: 80px;
    .ant-form {
      margin: 16px 0 0;
      .ant-form-item-with-help {
        margin-bottom: 0;
      }
    }
    .ant-row {
      padding-left: 0;
    }
    .ant-form-item-label {
      float: left;
      width: 60px;
      margin-left: -80px;
      label {
      color: #666;
      }
    }
    .ant-form-item-control-wrapper {
      float: left;
      width: 100%;
    }
  }
}
.relate-pro-tip {
  color: #b3b3b3;
  font-size: 12px;
  line-height: 20px;
  padding-top: 8px;
  padding-bottom: 16px;
}
.relate-pro-item {
  margin-bottom: 16px;
}
.relate-pro-alert {
  margin: 24px 0;
}
</style>
<style lang="scss">
  .relate-tip {
    .ant-btn{
    i{
      display: none;
    }
  }
  }
</style>
